// https://segmentfault.com/q/1010000000148290
export function clone(target) {
  if (typeof target !== 'object' || target === null) {
    return target
  }
  if (target instanceof Array) {
    let newArr = [];
    for (let i = 0; i < target.length; i++) {
      newArr.push(clone(target[i]));
    }
    return newArr;
  }
  let newObj = new Object();
  for (var i in target) {
    newObj[i] = clone(target[i]);
  }

  return newObj;
}



// WEBPACK FOOTER //
// ./src/common/js/clone.js